import React from "react"

interface TransitionStat {
  transition: string
  average: number
  totalCount: number
}

interface TransitionStatsCardsProps {
  fastestTransitions: TransitionStat[]
  slowestTransitions: TransitionStat[]
  getStateDisplayName: (state: string) => string
}

const TransitionStatsCards: React.FC<TransitionStatsCardsProps> = ({
  fastestTransitions,
  slowestTransitions,
  getStateDisplayName,
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      {/* Fastest Transitions */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="bg-green-500 rounded-lg p-2">
            <span className="text-white text-lg">⚡</span>
          </div>
          <h3 className="text-lg font-semibold text-gray-900">En Hızlı Geçişler</h3>
        </div>
        <div className="space-y-3">
          {fastestTransitions.slice(0, 5).map((transition, index) => {
            const [from, to] = transition.transition.split("_TO_")
            const averageHours = Math.round(transition.average / (1000 * 60 * 60))
            const averageDays = Math.round(averageHours / 24)
            return (
              <div
                key={index}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div>
                  <p className="font-medium text-gray-900">
                    {getStateDisplayName(from)} → {getStateDisplayName(to)}
                  </p>
                  <p className="text-sm text-gray-500">{transition.totalCount} başvuru</p>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-green-600">
                    {averageDays > 0 ? `${averageDays} gün` : `${averageHours} saat`}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      {/* Slowest Transitions */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="bg-red-500 rounded-lg p-2">
            <span className="text-white text-lg">🐌</span>
          </div>
          <h3 className="text-lg font-semibold text-gray-900">En Yavaş Geçişler</h3>
        </div>
        <div className="space-y-3">
          {slowestTransitions.slice(0, 5).map((transition, index) => {
            const [from, to] = transition.transition.split("_TO_")
            const averageHours = Math.round(transition.average / (1000 * 60 * 60))
            const averageDays = Math.round(averageHours / 24)
            return (
              <div
                key={index}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div>
                  <p className="font-medium text-gray-900">
                    {getStateDisplayName(from)} → {getStateDisplayName(to)}
                  </p>
                  <p className="text-sm text-gray-500">{transition.totalCount} başvuru</p>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-red-600">
                    {averageDays > 0 ? `${averageDays} gün` : `${averageHours} saat`}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default TransitionStatsCards
